<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<h2 mat-dialog-title>{{ data.field }} bearbeiten</h2>
<mat-dialog-content class="pad-top">
  
  <div *ngIf="data.field === 'Namen'">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Vorname</mat-label>
      <input matInput [disabled]="loading" [(ngModel)]="data.value.firstName" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nachname</mat-label>
      <input matInput [disabled]="loading" [(ngModel)]="data.value.lastName" />
    </mat-form-field>
  </div>

  <div *ngIf="data.field === 'Adresse'">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Straße</mat-label>
      <input matInput [disabled]="loading" [(ngModel)]="data.value.street" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>PLZ</mat-label>
      <input matInput [disabled]="loading" [(ngModel)]="data.value.zipCode" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Stadt</mat-label>
      <input matInput [disabled]="loading" [(ngModel)]="data.value.city" />
    </mat-form-field>
  </div>

  <div *ngIf="data.field === 'Geburtstag'">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Birth Date</mat-label>
      <input
        matInput
        [disabled]="loading"
        [matDatepicker]="picker"
        [(ngModel)]="data.value"
        (input)="onRawDateInput($event, 'birthDate')"
        placeholder="TT.MM.JJJJ"
        maxlength="10"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>

  <div *ngIf="data.field === 'E-Mail'">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ data.field }}</mat-label>
      <input matInput [disabled]="loading" [(ngModel)]="data.value" />
    </mat-form-field>
  </div>

  <div *ngIf="data.field === 'Telefonnummer'">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ data.field }}</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="data.value"
        type="tel"
        matInput
        placeholder="0123456789"
        pattern="^[0-9]*$"
      />
    </mat-form-field>
  </div>
  <div *ngIf="data.field === 'Termin'">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Termin</mat-label>
      <input
        matInput
        [disabled]="loading"
        [matDatepicker]="appointmentPicker"
        [(ngModel)]="datePart"
        (input)="onRawDateInput($event, 'appointment')"
        placeholder="TT.MM.JJJJ"
        maxlength="10"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="appointmentPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #appointmentPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Uhrzeit</mat-label>
      <input
        matInput
        type="time"
        [(ngModel)]="timePart"
        placeholder="HH:mm"
        [disabled]="loading"
      />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-button (click)="save()">Save</button>
</mat-dialog-actions>
